import _get2 from "lodash/get";
/* eslint-disable import/no-dynamic-require,react/no-danger */
import * as React from 'react';
import classnames from 'classnames';
import ReactHTMLParser from 'react-html-parser';
import { Heading5 } from '@latitude/heading';
import { Text } from '@latitude/text';
import { geURLParameterByName } from '@latitude/core';
import './_login-modal.scss';

/**
 * Login modal which pops up at certain URLS such as
 * https://www.latitudefinancial.com.au/?showLoginModal=activateinfinitycard
 */

/**
 * Determine which modal we need to show (if any) depending on the search part of the URL
 *
 * @param modalsData - list of modal data to search from
 * @returns {LoginModalData} modal data object
 */
export const getLoginModalData = modalsData => {
  const search = window.location.search;
  let modal = null;
  // Get the search part of the current URL
  const campaign = geURLParameterByName(search, 'showLoginModal');
  if (campaign) {
    // Use lodash get in case the filtered array is empty, and IE doesn't support ES6 Array.find
    modal = _get2(modalsData.filter(el => el.id === campaign), '0', null);
  }
  return modal;
};

/**
 * Login modal component
 */
export const LoginModal = props => {
  const {
    isOpen,
    className,
    data,
    onRequestClose,
    // eslint-disable-next-line no-unused-vars
    renderLoginModalImage = function (imageFileName) {
      if (imageFileName === void 0) {
        imageFileName = '';
      }
      return null;
    },
    setImageModuleSyntax
  } = props;
  if (!(isOpen && data)) {
    return null;
  }

  // check card image
  const cardImageFileName = data.card || '';
  const cardImageElement = renderLoginModalImage(cardImageFileName);

  // console.log({ cardImageElement });
  // console.log(cardImageElement.props.src);

  const cardImageSrc = setImageModuleSyntax ? cardImageElement.props.src.default : cardImageElement.props.src;
  console.log(cardImageSrc);
  return /*#__PURE__*/React.createElement("div", {
    className: classnames('login-modal', className)
  }, /*#__PURE__*/React.createElement("div", {
    className: "modal-backdrop show"
  }), /*#__PURE__*/React.createElement("div", {
    className: "login-modal__triangle"
  }), /*#__PURE__*/React.createElement("div", {
    className: `login-modal__content ${cardImageElement === null ? 'login-modal__content--no-image' : ''} bg-white`
  }, /*#__PURE__*/React.createElement("img", {
    src: cardImageSrc,
    alt: "Credit Card"
  }), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "close",
    "data-dismiss": "modal",
    "aria-label": "Close",
    onClick: onRequestClose
  }, /*#__PURE__*/React.createElement("div", {
    "aria-hidden": "true"
  }, "\xD7")), /*#__PURE__*/React.createElement(React.Fragment, null, data.header && /*#__PURE__*/React.createElement(Heading5, {
    className: "login-modal__heading"
  }, data.header), data.text && /*#__PURE__*/React.createElement(Text, {
    className: "login-modal__text"
  }, ReactHTMLParser(data.text)))));
};